import { DialogInfo } from 'components/dialog-info';
import React, { useMemo } from 'react';
import { apiPages } from 'services/pages';
import { sanitizeHtmlContent } from 'utils/sanitize';
interface Props {
  onClose: () => void;
}

export const DialogPrivacy: React.FC<Props> = ({ onClose }) => {
  const { data, isLoading } = apiPages.endpoints.getPrivacy.useQuery();

  const html = useMemo(() => {
    return sanitizeHtmlContent(data?.htmlURL || '');
    // return data?.htmlURL;
  }, [data]);

  return (
    <DialogInfo title={data?.title || ''} html={html} isLoading={isLoading} onClose={onClose} />
  );
};
